import React from 'react'
import { OverlayTrigger, Tooltip as BootstrapTooltip } from 'react-bootstrap'

import { VariableFormTemplateMappingSourceId } from '../../../../models/FormTemplate'
import { Descriptor, UiSchemaDescriptor } from '../../../../models/Scorecard'

import { FORM_FIELD_TYPE_TO_FORM_FIELD_LABEL_MAPPING } from '../../AIForms/model'

import { FORM_TEMPLATE_VARIABLE_SOURCE_ID_TO_LABEL_MAPPING, getFormFieldTypeFromDescriptor } from '../utils'

interface FormFieldFormTemplateMappingSourceColumnProps {
  descriptor: Descriptor
  uiSchemaDescriptor?: UiSchemaDescriptor
  option?: string
  showSpacer?: boolean
}

export const FormFieldFormTemplateMappingSourceColumn: React.FC<FormFieldFormTemplateMappingSourceColumnProps> = ({
  descriptor,
  uiSchemaDescriptor,
  option,
  showSpacer = false,
}) => {
  const formFieldType = getFormFieldTypeFromDescriptor(descriptor, uiSchemaDescriptor)

  return (
    <div className='w-50 d-flex align-items-center'>
      <div className='d-flex align-items-center flex-grow-1 px-3 zocks-py-0.75 gap-2'>
        {option ? (
          <>
            <i className='bi bi-arrow-return-right' />
            <span className='paragraph-medium'>{option}</span>
          </>
        ) : (
          <>
            <div className='d-flex align-items-center gap-1'>
              <span className='paragraph-medium'>{descriptor.title}</span>
              <span className='paragraph-small zocks-text-gray-600'>({FORM_FIELD_TYPE_TO_FORM_FIELD_LABEL_MAPPING[formFieldType]})</span>
            </div>
            {descriptor.description ? (
              <OverlayTrigger
                trigger={['hover', 'focus']}
                placement='top'
                overlay={<BootstrapTooltip className='zocks-text-gray-500'>{descriptor.description}</BootstrapTooltip>}
              >
                <i className='bi bi-info-square zocks-text-gray-600' />
              </OverlayTrigger>
            ) : null}
          </>
        )}
      </div>
      {showSpacer ? (
        <div className='form-template-update-spacer' />
      ) : (
        <div className='px-3 zocks-py-0.75'>
          <i className='bi bi-arrow-right' />
        </div>
      )}
    </div>
  )
}

interface VariableFormTemplateMappingSourceColumnProps {
  variableId: VariableFormTemplateMappingSourceId
}

export const VariableFormTemplateMappingSourceColumn: React.FC<VariableFormTemplateMappingSourceColumnProps> = ({ variableId }) => {
  return (
    <div className='w-50 d-flex align-items-center'>
      <div className='d-flex align-items-center flex-grow-1 px-3 zocks-py-0.75 gap-1'>
        <span className='paragraph-medium'>{FORM_TEMPLATE_VARIABLE_SOURCE_ID_TO_LABEL_MAPPING[variableId]}</span>
        <span className='paragraph-small zocks-text-gray-600'>(Variable)</span>
      </div>
      <div className='px-3 zocks-py-0.75'>
        <i className='bi bi-arrow-right' />
      </div>
    </div>
  )
}
